export default __webpack_public_path__ + "static/media/minisite-pagetype-email_register.de2e2d40.svg";